import React from "react";
import { withStyles } from "@material-ui/core/styles";
import PaymentHeader from "./PaymentHeader";
import {
  convertToUSDollars,
} from "./util";

const styles = (theme) => ({
  paymentLabel: {
    color: theme.dispatchPanelLabelValueColor,
    fontSize: theme.headerTextFontSize,
    fontWeight: 500,
    lineHeight: "19px",
    display: "flex",
    width: "50%",
    marginTop: "11px",
  },
  columnContainer: {
    color: theme.dispatchPanelLabelValueColor,
    fontSize: theme.headerTextFontSize,
    display: "flex",
    flexWrap: "wrap",
    flexGrow: 1,
    flexDirection: "column",
    marginTop: 12,
    alignItems: "flex-end",
  },
  rowContainer: {
    display: "flex",
  },
});

const PaidCharges = ({ classes, data }) => {
  const {
    originalFreightAmount,
    originalCodAmount,
    paidFreightCharge,
    paidCodCharge,
  } = data;
 
  return (<>
    <PaymentHeader label="PAID CHARGES"/>
    {paidFreightCharge > 0 &&
      <div className={classes.rowContainer}>
        <div className={classes.paymentLabel}>
          Original Freight Charges
        </div>
        <div className = {classes.columnContainer}>
          {convertToUSDollars(originalFreightAmount)} <br/><br/>
          Amount Paid <br/>
          {convertToUSDollars(paidFreightCharge)}
        </div>
      </div>
    }
    {paidCodCharge > 0 &&
      <div className={classes.rowContainer}>
        <div className={classes.paymentLabel}>
          Original COD Charges
        </div>
        <div className = {classes.columnContainer}>
          {convertToUSDollars(originalCodAmount)} <br/><br/>
          Amount Paid <br/>
          {convertToUSDollars(paidCodCharge)}
        </div>
      </div>
    }
  </>)
}

export default withStyles(styles)(PaidCharges);


